import * as React from 'react';
import { StoreContext } from '../utils';
import { LehrerAside } from './Aside/LehrerAside';
import { LehrerTopBar } from './LehrerTopBar';
import { Store } from '../store/Store';
import { BasicPortalStructure } from '../layout/BasicPortalStructure';

export interface Props {
  store: Store;
}

export class LehrerPortal_ extends React.Component<Props, {}> {
  render() {
    const { children, store } = this.props;
    return (
      <StoreContext.Provider value={store}>
        <BasicPortalStructure aside={<LehrerAside />} content={children} />
      </StoreContext.Provider>
    );
  }
}
